import classnames from 'classnames';
import React from 'react';
import styles from './ExternalLink.scss';
import { IInner, IOuter } from './ExternalLink.types';

export const ExternalLinkComponent: React.FC<IOuter & IInner> = ({ href, className, ...otherProps }) => (
  <a
    target="_blank"
    {...otherProps}
    href={href}
    className={classnames(styles.externalLink, className)}
    rel="noopener noreferrer"
  />
);
